import { OrganizationSearchFieldProps } from './OrganizationSearchField.types'
import { SearchField } from './OrganizationSearchField.components'
import { useOrganizationSearchFieldState } from './OrganizationSearchField.hooks'
import React from 'react'

export const OrganizationSearchField: React.FC<OrganizationSearchFieldProps> = props => {
  const { loading, searchResults, searchTerm, setSearchTerm } =
    useOrganizationSearchFieldState(props)
  return (
    <SearchField
      onRefInitialized={props.onRefInitialized}
      placeholder={props.placeholder ?? ''}
      label={props.label ?? ''}
      loading={loading}
      onFocus={props.onFocus}
      results={searchResults}
      inputValue={searchTerm}
      setInputValue={setSearchTerm}
      onResultClicked={props.onSearchResultClicked}
      searchFor={props.searchFor}
      fromInternalAdmin={props.fromInternalAdmin}
      inputType={props.searchInputType}
    />
  )
}
